<script setup lang="ts">
import SiteEditableText from '../../SiteEditableText.vue'
import SiteLink from '../../SiteLink.vue'
import type { FaqBlock } from '../../types'

defineProps<{ block: FaqBlock }>()
</script>

<template>
  <section :id="block.settings.anchorId" class="site:bg-(--site-color-background) site:py-16 site:@min-[40rem]:py-24">
    <div class="site-site-container site:grid site:gap-12 site:@min-[64rem]:grid-cols-[0.72fr_1.28fr] site:@min-[64rem]:gap-20">
      <div>
        <SiteEditableText v-if="block.content.eyebrow" v-model="block.content.eyebrow" as="p" class="site:text-sm site:font-semibold site:text-(--site-color-primary)" />
        <SiteEditableText v-model="block.content.heading" as="h2" class="site-heading site:mt-3 site:text-3xl site:font-bold site:tracking-tight site:@min-[40rem]:text-5xl" />
        <SiteEditableText v-if="block.content.description" v-model="block.content.description" as="p" class="site:mt-5 site:text-lg site:leading-8 site:text-(--site-color-muted-text)" />
        <SiteLink v-if="block.content.action" :link="block.content.action" class="site-site-button-secondary site:mt-7">
          {{ block.content.action.label }}
        </SiteLink>
      </div>

      <div class="site:border-t site:border-(--site-color-border)">
        <details v-for="item in block.content.items" :key="item.id" class="site:group site:border-b site:border-(--site-color-border) site:py-1">
          <summary class="site:flex site:min-h-20 site:list-none site:items-center site:justify-between site:gap-5 site:py-5 site:text-left site:[&::-webkit-details-marker]:hidden">
            <SiteEditableText v-model="item.question" as="span" class="site-heading site:text-lg site:font-bold" />
            <span class="site:text-2xl site:font-light site:text-(--site-color-primary) site:transition-transform site:group-open:rotate-45" aria-hidden="true">+</span>
          </summary>
          <SiteEditableText v-model="item.answer" as="p" class="site:max-w-2xl site:pb-6 site:pr-10 site:leading-7 site:text-(--site-color-muted-text)" />
        </details>
      </div>
    </div>
  </section>
</template>
